function extractDeliveryDate(
    deliveryMode: string | undefined,
    fulfillmentType: string | undefined,
    possibleDeliveryModes: Record<string, any> | null | undefined
) {
    if (deliveryMode && fulfillmentType) {
        const deliveryDate =
            possibleDeliveryModes?.[deliveryMode]?.possibleFulfillmentTypes?.[fulfillmentType]?.relativeLeadtime
                ?.deliveryDate;
        return deliveryDate;
    }
    return null;
}

export default extractDeliveryDate;
